interface AdBannerProps {
  slotId: string;
  format?: 'auto' | 'horizontal' | 'rectangle' | 'fluid';
  className?: string;
}
// Ad serving is paused during the content rebuild. Ownership verification lives
// in index.html and ads.txt. Re-enable only with the production CMP integration.
export default function AdBanner(_props: AdBannerProps) { return null; }
